import React from 'react';
import style from './Backdrop.module.css';

const Backdrop = () => {
	return <div className={style.backdrop}></div>;
};

export default Backdrop;
